export type CategoryId = "musica" | "video" | "nube" | "productividad" | "juegos";

export type SessionStatus = "draft" | "open" | "closed" | "expired";

export interface ServiceDefinition {
  id: string;
  name: string;
  shortName: string;
  category: CategoryId;
  plan: string;
  monthlyPriceCents: number;
  sourceUrl: string;
  verifiedAt: string;
  glyph: string;
}

export interface CatalogSnapshot {
  currency: "MXN";
  locale: "es-MX";
  verifiedAt: string;
  services: ServiceDefinition[];
}

export interface SessionSummary {
  id: string;
  slug: string;
  title: string;
  status: SessionStatus;
  createdAt: number;
  openedAt: number | null;
  closedAt: number | null;
  expiresAt: number | null;
  responseCount: number;
  mode: "live" | "demo";
}

export interface SessionPublic {
  slug: string;
  title: string;
  status: SessionStatus;
  mode: "live" | "demo";
  catalog: CatalogSnapshot;
  openedAt: number | null;
  closedAt: number | null;
  expiresAt: number | null;
}

export interface ActiveSessionPublic {
  slug: string;
  title: string;
  status: "open";
  openedAt: number;
}

export interface HistogramBucket {
  id: string;
  label: string;
  minCents: number;
  maxCents: number | null;
  count: number;
}

export interface ServiceMetric {
  serviceId: string;
  name: string;
  category: CategoryId;
  count: number;
  adoptionRate: number;
  monthlySpendCents: number;
}

export interface CategoryMetric {
  category: CategoryId;
  count: number;
  monthlySpendCents: number;
}

export interface MetricsSnapshot {
  type: "metrics";
  version: number;
  sessionSlug: string;
  status: SessionStatus;
  responseCount: number;
  totalMonthlyCents: number;
  totalSixMonthsCents: number;
  totalAnnualCents: number;
  meanMonthlyCents: number;
  medianMonthlyCents: number;
  averageServiceCount: number;
  histogram: HistogramBucket[];
  services: ServiceMetric[];
  categories: CategoryMetric[];
  lastSubmissionAt: number | null;
  connectedDashboards: number;
}

export interface ParticipantResponse {
  participantToken: string;
  serviceIds: string[];
}

export interface ParticipantReceipt {
  responseId: string;
  selectedServiceIds: string[];
  monthlyTotalCents: number;
  sixMonthTotalCents: number;
  annualTotalCents: number;
  updatedAt: number;
  catalogVerifiedAt: string;
}

export interface DemoResponse {
  participantToken: string;
  serviceIds: string[];
}

export const CATEGORY_LABELS: Record<CategoryId, string> = {
  musica: "Música",
  video: "Video",
  nube: "Nube",
  productividad: "Productividad",
  juegos: "Juegos",
};
